<template>
    <v-dialog v-model="dialog" max-width="960" @click:outside="cancel">
        <v-card class="no-padding">
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="cancel">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Medical Record Followups</v-toolbar-title>
            </v-toolbar>
            <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
            <v-data-table v-else
                :items="records"
                :items-per-page="5"
                :footer-props="{ 'items-per-page-options': [10,20,50,-1] }"
                :headers="mainHeaders"
                item-key="FollowupRecordID"
                sort-by="FollowupRecordID"
                :sort-desc="true">

                <template v-slot:item.FollowupDate="{ item }">
                    {{ item.FollowupDate | formatDateOnly }}
                </template>
                <template v-slot:item.AssignedVetUser="{ item }">
                    <template v-if="item.AssignedVetUser === null">
                        Unassigned
                    </template>
                    <template v-else>
                        {{ item.AssignedVetUser }}
                    </template>
                </template>
                <template v-slot:item.View="{ item }">
                    <v-btn
                        color="accent"
                        @click="openMedicalRecord(item.MedicalRecordID, item.SpecimenID, item.SpecimenDisplayID)"
                    >
                        Edit
                    </v-btn>
                </template>
            </v-data-table>
            <v-container>
                <v-row no-gutters>
                    <v-col cols="12" md="6" offset-md="3">
                        <v-alert text type="error" v-if="loadingError">
                            {{loadingError}}
                        </v-alert> 
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="12" md="6" offset-md="3">
                        <v-row>
                            <v-col cols="6" v-if="!params.allVetFollowups">
                                <v-btn color="primary darken-1" @click="loadAllVetFollowups" :disabled="saving" :loading="saving" block>All Vet Followups</v-btn>
                            </v-col>
                            <v-col cols="6" v-if="!params.allFollowupsOfCurrentUser">
                                <v-btn color="warning" @click="loadFollowupsOfCurrentUser" :loading="saving" block>All My Followups</v-btn>
                            </v-col>
                            <v-col cols="6" v-if="params.allVetFollowups || params.allFollowupsOfCurrentUser">
                                <v-btn color="info" @click="reset" :loading="saving" block>Past Followups</v-btn>
                            </v-col>
                        </v-row>
                        <v-spacer></v-spacer>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
    </v-dialog>
</template>

<script>
import medicalRecordAPI from '../../services/medicalRecordAPI';
import moment from 'moment';
import { mapGetters } from 'vuex';
import constants from 'comunet-btg-utah-repository-shared/constants';

export default {
     components: {

    },
    props: {
         dialog: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            loading: false,
            records: [],
            expanded: [],
            loadingError: "",
            params:{
                allFollowupsOfCurrentUser: true,
                allVetFollowups: false
            },
            mainHeaders: [
                {
                    text: "SpecimenID",
                    value: "SpecimenDisplayID"
                },
                {
                    text: "Medical Record ID",
                    value: "MedicalRecordID"
                },
                {
                    text: "Assigned To",
                    value: "AssignedVetUser"
                },
                {
                    text: "Followup Date",
                    value: "FollowupDate"
                },
                {
                    text: "",
                    value: "View"
                },
                { 
                    text: '', 
                    value: 'data-table-expand' 
                }
            ]
        };
    },
    filters: {
        // ensure data stored as a date only (ie no timezone) is formatted correctly
        formatDateOnly: function(value) {
            return moment.utc(value).format(constants.DATE_FORMAT_NO_TIME);
        }
    },
    computed:{
        permission:function(){
            return this.$store.state.authStore.user.UserProfile.Permissions.admin;
        },
        vetUsers() {
            return this.$store.state.userStore.vetUsers;
        },
        ...mapGetters({
            vetUsers: "userStore/getVetUsers",
        }),
    },
    methods: {
        loadUsers() {
            this.$store.dispatch("userStore/loadUsers");
        },
        openMedicalRecord(medicalRecordID, specimenID, specimenDisplayID) {
            this.$router.push({ name: 'medicalRecordDetails', params: { medicalRecordID: medicalRecordID}, query:{ SpecimenID: specimenID, SpecimenDisplayID: specimenDisplayID} });
            this.cancel();
        },
        async loadFollowups() {
            this.loading = true;
            this.loadingError = "";

            try {
                this.records = await medicalRecordAPI.getFollowups(this.params);
                this.expanded = [ this.records[0] ]
            } catch (e) {
                this.loadingError = e.message
            }

            this.loading = false;
        },
        async loadFollowupsOfCurrentUser() {
            this.params.allFollowupsOfCurrentUser = true;
            this.params.allVetFollowups = false;
            await this.loadFollowups();
        },
        async loadAllVetFollowups() {
            this.params.allVetFollowups = true;
            this.params.allFollowupsOfCurrentUser = false;
            await this.loadFollowups();
        },
        async reset() {
            this.params = {
                allFollowupsOfCurrentUser: true,
                allVetFollowups: false
            };
            await this.loadFollowups();

        },
        cancel() {
            this.$emit('cancel');
            this.dialog = false;
        }
},

async created() {
    await Promise.all([this.loadUsers(), this.loadFollowups()]);
},

}
</script>

<style>
    .min-width-column {
        width: 1%;
    }
</style>

<style scoped>
    .expansion-panel {
        background-color: white;
    }
</style>